<div class="rq-builder">
  <div class="rq-info">
    <i class="dx-icon dx-icon-info"></i>
    <span
      class="rq-description"
      [innerHTML]="'REGISTRATION-LINKS.QUESTIONS.BASE-INFO' | translate"
    ></span>
  </div>

  @if (!questions.length) {
    <div class="rq-note">
      {{ 'REGISTRATION-LINKS.QUESTIONS.EMPTY' | translate }}
    </div>
  }

  @for (q of questions; track q; let i = $index; let last = $last) {
    <div
      class="rq-card"
      [class.open]="openQuestion === q"
    >
      <div class="rq-head" (click)="toggle(q)">
        <span class="rq-num">{{ i + 1 }}</span>

        <span class="rq-title" [class.question-placeholder]="!q.text">
          {{ q.text || ('REGISTRATION-LINKS.QUESTIONS.NEW-QUESTION' | translate) }}
        </span>

        @if (q.isRequired) {
          <span class="rq-required">
            {{ 'REGISTRATION-LINKS.QUESTIONS.REQUIRED' | translate }}
          </span>
        }

        <span class="rq-type">{{ typeLabel(q.type) }}</span>

        @if (hasOptions(q)) {
          <span class="rq-mapped">
            {{ mappedCount(q) }}/{{ q.options.length }}
            {{ 'REGISTRATION-LINKS.QUESTIONS.MAPPED' | translate }}
          </span>
        }

        <dx-button
          *ngIf="i !== 0"
          icon="arrowup"
          type="default"
          [hint]="'REGISTRATION-LINKS.QUESTIONS.MOVE-UP' | translate"
          (onClick)="move($event, q, -1)"
        ></dx-button>

        <dx-button
          *ngIf="!last"
          icon="arrowdown"
          type="default"
          [hint]="'REGISTRATION-LINKS.QUESTIONS.MOVE-DOWN' | translate"
          (onClick)="move($event, q, 1)"
        ></dx-button>

        <dx-button
          icon="trash"
          stylingMode="text"
          type="danger"
          [hint]="'REGISTRATION-LINKS.QUESTIONS.DELETE-QUESTION' | translate"
          (onClick)="remove($event, q)"
        ></dx-button>
      </div>

      @if (openQuestion === q) {
        <div class="rq-body">
          <div class="rq-row">
            <dx-text-box
              [(value)]="q.text"
              valueChangeEvent="input"
              stylingMode="outlined"
              [label]="('REGISTRATION-LINKS.QUESTIONS.QUESTION' | translate) + ' *'"
              [placeholder]="'REGISTRATION-LINKS.QUESTIONS.QUESTION-PLACEHOLDER' | translate"
            >
              <dx-validator validationGroup="registrationQuestions">
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.QUESTION-TEXT-REQUIRED' | translate"
                ></dxi-validation-rule>
                <dxi-validation-rule
                  type="stringLength"
                  [min]="1"
                  [trim]="true"
                  [message]="'VALIDATIONS.QUESTION-TEXT-REQUIRED' | translate"
                ></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>

            <dx-select-box
              [items]="typeItems"
              valueExpr="id"
              displayExpr="text"
              [value]="q.type"
              labelMode="floating"
              stylingMode="outlined"
              [label]="'REGISTRATION-LINKS.QUESTIONS.ANSWER-TYPE' | translate"
              [searchEnabled]="false"
              (onValueChanged)="changeType(q, $event.value)"
            ></dx-select-box>

            <div class="rq-switch">
              <mat-slide-toggle
                [(ngModel)]="q.isRequired"
                class="req-toggle"
              ></mat-slide-toggle>

              <span>
                {{ 'REGISTRATION-LINKS.QUESTIONS.REQUIRED' | translate }}
              </span>
            </div>
          </div>

          <dx-text-box
            [value]="q.hint ?? ''"
            (valueChange)="q.hint = $event || null"
            valueChangeEvent="input"
            labelMode="floating"
            stylingMode="outlined"
            [label]="'REGISTRATION-LINKS.QUESTIONS.HINT' | translate"
            [placeholder]="'REGISTRATION-LINKS.QUESTIONS.HINT-PLACEHOLDER' | translate"
          ></dx-text-box>

          @if (q.type === types.Text) {
            <div class="rq-note">
              {{ 'REGISTRATION-LINKS.QUESTIONS.TEXT-NOTE' | translate }}
            </div>
          } @else {
            <div class="rq-options">
              <div class="rq-opt rq-opt-head">
                <span>
                  {{ 'REGISTRATION-LINKS.QUESTIONS.ANSWER' | translate }}
                </span>
                <span></span>
                <span>
                  {{ 'REGISTRATION-LINKS.QUESTIONS.SETS-TRAINING-GROUPS' | translate }}
                </span>
                <span></span>
              </div>

              @for (o of q.options; track o) {
                <div class="rq-opt">
                  <dx-text-box
                    [(value)]="o.text"
                    valueChangeEvent="input"
                    stylingMode="filled"
                    [readOnly]="q.type === types.YesNo"
                    [placeholder]="'REGISTRATION-LINKS.QUESTIONS.ANSWER-OPTION' | translate"
                  >
                    @if (q.type !== types.YesNo) {
                      <dx-validator validationGroup="registrationQuestions">
                        <dxi-validation-rule
                          type="required"
                          [message]="'VALIDATIONS.ANSWER-OPTION-REQUIRED' | translate"
                        ></dxi-validation-rule>
                        <dxi-validation-rule
                          type="stringLength"
                          [min]="1"
                          [trim]="true"
                          [message]="'VALIDATIONS.ANSWER-OPTION-REQUIRED' | translate"
                        ></dxi-validation-rule>
                      </dx-validator>
                    }
                  </dx-text-box>

                  <span class="rq-arrow">→</span>

                  <dx-drop-down-box
                    [(value)]="o.trainingGroupIds"
                    [inputAttr]="{ 'aria-label': 'Training groups' }"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="'COMMON.FIELDS.TRAINING-GROUPS' | translate"
                    [dataSource]="trainingGroups"
                    labelMode="floating"
                    stylingMode="outlined"
                    class="tg-selector"
                  >
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        #treeView
                        [searchEnabled]="true"
                        [dataSource]="trainingGroups"
                        dataStructure="plain"
                        keyExpr="id"
                        selectionMode="multiple"
                        showCheckBoxesMode="normal"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        [selectByClick]="true"
                        (onInitialized)="syncTrainingGroupSelection(treeView, o.trainingGroupIds)"
                        (onItemSelectionChanged)="onTrainingGroupSelected(o, $event)"
                      ></dx-tree-view>
                    </div>
                  </dx-drop-down-box>

                  @if (q.type === types.YesNo) {
                    <span></span>
                  } @else {
                    <dx-button
                      icon="close"
                      stylingMode="text"
                      type="danger"
                      [disabled]="q.options.length <= 2"
                      [hint]="'REGISTRATION-LINKS.QUESTIONS.REMOVE-ANSWER' | translate"
                      (onClick)="removeOption(q, o)"
                    ></dx-button>
                  }
                </div>
              }

              @if (q.type !== types.YesNo) {
                <dx-button
                  class="rq-add-option"
                  icon="plus"
                  type="default"
                  [text]="'REGISTRATION-LINKS.QUESTIONS.ADD-ANSWER' | translate"
                  (onClick)="addOption(q)"
                ></dx-button>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="rq-add">
    <span class="rq-add-label">
      {{ 'REGISTRATION-LINKS.QUESTIONS.ADD-QUESTION' | translate }}
    </span>

    @for (t of typeItems; track t.id) {
      <dx-button
        type="default"
        [text]="'+ ' + t.text"
        (onClick)="add(t.id)"
      ></dx-button>
    }
  </div>
</div>